import { Link } from "react-router-dom"
import { Twitter, Instagram, Shield, FileText, Mail } from "lucide-react"
import { useQuery } from "@tanstack/react-query"
import { useTranslation } from "react-i18next"
import { api } from "../lib/api"
import { NetworkBadge } from "./NetworkBadge"

export default function Footer() {
  const { t } = useTranslation()
  const { data } = useQuery({
    queryKey: ["events", "upcoming-count"],
    queryFn: () => api.get<{ events: Array<{ state?: string; scheduledEndUtc?: string; isPublic?: boolean }> }>("/events/get-upcoming-events?limit=20"),
    staleTime: 5 * 60 * 1000,
  })

  const upcomingEventsCount = data?.events?.filter(
    (event) => {
      if (event.state === "Ended" || event.state === "Completed" || event.state === "Cancelled") return false
      if (event.scheduledEndUtc && new Date(event.scheduledEndUtc) <= new Date()) return false
      return event.isPublic
    }
  ).length ?? 0

  return (
    <footer className="hidden md:block w-full border-t border-border bg-background mt-[10px]">
      <div className="max-w-7xl mx-auto px-4 py-3">
        <div className="flex items-center justify-between gap-4 flex-wrap">
          <div className="flex items-center gap-4">
            <a
              href="https://x.com/creatixevents?s=21&t=tz_sYJ9gHDiHULKBpU4b5w"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#8E8E93] hover:text-foreground transition"
              aria-label={t("footer.xAria")}
            >
              <Twitter className="w-4 h-4" />
            </a>
            <a
              href="https://www.instagram.com/creatix.events?igsh=NWtmNmJ3bHU5ZDll"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#8E8E93] hover:text-foreground transition"
              aria-label={t("footer.instagramAria")}
            >
              <Instagram className="w-4 h-4" />
            </a>
            <a
              href="mailto:creatixplatform@gmail.com"
              className="text-[#8E8E93] hover:text-foreground transition"
              aria-label={t("footer.emailAria")}
            >
              <Mail className="w-4 h-4" />
            </a>
          </div>

          <div className="flex items-center gap-2 text-sm text-foreground-secondary">
            <span>{t("footer.brand")}</span>
            <span className="text-foreground-secondary/30">|</span>
            <span>{t("footer.tagline")}</span>
            <NetworkBadge size="md" />
          </div>

          <div className="flex items-center gap-4">
            <div className="text-sm text-foreground-secondary">
              {t("footer.upcomingEventCount", { count: upcomingEventsCount })}
            </div>
            <span className="text-foreground-secondary">|</span>
            <div className="flex items-center gap-4">
              <Link
                to="/privacy"
                className="text-foreground-secondary hover:text-foreground transition"
                aria-label={t("footer.privacyAria")}
              >
                <Shield className="w-4 h-4" />
              </Link>
              <Link
                to="/terms"
                className="text-foreground-secondary hover:text-foreground transition"
                aria-label={t("footer.termsAria")}
              >
                <FileText className="w-4 h-4" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}
